import {
  DropdownSelector,
  SelectorType,
} from '@vimily/bonjoro-ui-components-v2/DropdownSelector';
import React, { useMemo } from 'react';
import usePagination from '~/react-hooks/usePagination';
import { UserSimple } from '~/types/models';
import cx from 'classnames';

export interface TeamMemberSelectorProps {
  className?: string;
  bodyContainerClassName?: string;
  bodyContentClassName?: string;
  selectedUser?: UserSimple | null;
  hideAllSelector?: boolean;
  bodyPlaceholder?: string;
  width?: number;
  onSelect?: (assignee?: UserSimple) => void;
  showPlaceholderAsSelected?: boolean;
  disabled?: boolean;
}

export function TeamMemberSelector({
  className,
  bodyContainerClassName,
  bodyContentClassName,
  selectedUser,
  bodyPlaceholder = 'All members',
  hideAllSelector = false,
  width = 180,
  onSelect,
  showPlaceholderAsSelected,
  disabled = false,
}: TeamMemberSelectorProps) {
  const [assignees] = usePagination<UserSimple>('/api/v2/users', {
    infinite: true,
    key: 'users',
  });

  function onAssigneeSelect(assigneeId: string) {
    const assignee = assignees.find((assignee) => assignee.id == assigneeId);
    onSelect?.(assignee);
  }

  const items = useMemo(() => {
    const items = assignees.reduce((items, assignee) => {
      return {
        ...items,
        [assignee.id]: assignee.name ?? assignee.email,
      };
    }, {}) as Record<string, string>;

    if (hideAllSelector) {
      return items;
    }

    return {
      ['']: 'All members',
      ...items,
    };
  }, [assignees, hideAllSelector]);

  return (
    <DropdownSelector
      type={SelectorType.Select}
      items={items}
      bodyPlaceholder={bodyPlaceholder}
      selected={selectedUser ? [`${selectedUser?.id}`] : undefined}
      className={cx(className, 'z-50 h-10 v2-text-neutral-900 text-base')}
      bodyWidth={width}
      bodyContainerClassName={cx(bodyContainerClassName, 'h-10')}
      bodyContentClassName={bodyContentClassName}
      bodyLabelClassName='!text-base'
      dropdownProps={{
        width: 180,
        id: 'team-member-selector-container',
        containerClassName: 'z-99',
        containerAlignment: 'flex-start',
      }}
      onSelect={(selected) => onAssigneeSelect(selected[0])}
      showBodyPlaceholderAsSelected={showPlaceholderAsSelected}
      disabled={disabled}
      hideTooltip
    />
  );
}
